module.exports = __webpack_public_path__ + "static/media/ugrant-header-bg.b7328a94.svg";